import { showHttpError, showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { setFormErrors } from 'actions/form'

import { userGroupSelector } from './selectors'
import { getGroup, updateGroup } from '../../api'
import { destroyUserGroup } from '../../destroy/actions'


export const fetchGroup = createAsyncThunk(
  'userGroup/fetch',
  async ({ groupId, options = { onError: () => {} } }, { dispatch, rejectWithValue }) => {
    const [success, response] = await getGroup(groupId)

    if (!success) {
      options.onError()
      dispatch(showHttpError(response))
      return rejectWithValue([])
    }

    return response
  }
)

export const destroyGroup = (options = { onSuccess: () => {} }) => (dispatch, getState) => {
  const { id } = userGroupSelector(getState())

  dispatch(destroyUserGroup(id)).then(() => {
    options.onSuccess()
  })
}

const slice = createSlice({
  name: 'userGroup/groupManagement',
  initialState: { userGroup: {}, status: 'loading' },
  extraReducers: (builder) => {
    builder.addCase(fetchGroup.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(fetchGroup.fulfilled, (state, action) => {
      state.userGroup = action.payload
      state.status = 'loaded'
    })
    builder.addCase(fetchGroup.rejected, (state) => {
      state.status = 'failed'
    })
  }
})

export const updateUserGroup = (params) => async (dispatch, getState) => {
  const { id } = userGroupSelector(getState())
  const [success, response] = await updateGroup(id, params)

  if (!success) {
    dispatch(setFormErrors(response))
    return
  }

  dispatch(fetchGroup.fulfilled(response))
  dispatch(showSuccess(I18n.t('publisher.flash.saved')))
}

export const { reducer } = slice
